import { components } from "@api/api";
import useAxios from "@hooks/useFetch";
import { ID } from "@datassential/platform-ui-lib";
import { KeywordBase, useGetKeywordBaseData } from "@api/useGetKeywordBaseData";
import { HOME_SORT_BY_METRICS_ORDER, MetricBase, useMapMetricsForTable } from "@models/Metric";

const OTHER_FLAVORS_ENDPOINT = '/api/item/GetOtherFlavors/:id';

export type ProfileOtherItemsResponseRaw = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemOtherFlavors"];
export type ProfileOtherItemsResponseItem = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.OtherFlavors"];

export type ProfileOtherItem = KeywordBase & {
    metrics: MetricBase[];
}

export type ProfileOtherItemsResponse = ProfileOtherItemsResponseRaw & {
    mostPopular: ProfileOtherItem[],
    fastestGrowing: ProfileOtherItem[],
};

export function useProfileOtherItems(id: ID): {
    isLoading: boolean;
    data: ProfileOtherItemsResponse;
} {
    const getKeywordBaseData = useGetKeywordBaseData(["knowItChange", "thumbnailUrl", "primaryCategoryId"]);
    const mapMetricsForTable = useMapMetricsForTable(HOME_SORT_BY_METRICS_ORDER);

    const response = useAxios<ProfileOtherItemsResponseRaw>({
        url: OTHER_FLAVORS_ENDPOINT.replace(':id', `${id}`),
        method: 'get',
    });

    const data = response.data ?? {
        mostPopular: [],
        fastestGrowing: [],
    };

    const mapKeywordAndMetrics = (item: ProfileOtherItemsResponseItem) => {
        const itemBase = getKeywordBaseData(item.id ?? 0);

        return {
            ...itemBase,
            metrics: mapMetricsForTable(item.metrics ?? [])
        };
    };

    return {
        ...response,
        data: {
            mostPopular: data.mostPopular?.map(mapKeywordAndMetrics) ?? [],
            fastestGrowing: data.fastestGrowing?.map(mapKeywordAndMetrics) ?? [],
        },
    };
}